import { getRequest, putRequest } from "../../services/api";

const path = "admin/offer-milestone";

export const searchRedeemCode = async (code) => {
  try {
    const response = await getRequest(`${path}/redeem/${code}`, true);
    return response;
  } catch (err) {
    throw err;
  }
};

export const approveRedeemCode = async (params) => {
  try {
    const response = await putRequest(`${path}/redeem/approve`, params, true);
    return response;
  } catch (err) {
    throw err;
  }
};
